module.exports = __webpack_public_path__ + "static/Hubspot-2a2b3708abe0c0d57d91f8dbe3d957ec.png";